export default __webpack_public_path__ + "static/media/dr-img.d04ffe3c.png";